// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3--P2","inner":"Footer_inner__2yq6q"};